import { PouchDbRepository } from "../../external";
import StorageHelper from "../../helpers/StorageHelper";
const storageHelper = new StorageHelper();

export class ProdutosLocalService {
  static database = "est-produtos";
  static databaseEmpresa = null;
  static dbLocalRepository;

  static startSincronizacao(empresaId) {
    if (!empresaId) return;
    const isSyncAtiva = this.dbLocalRepository?.syncHandler;
    if (isSyncAtiva) {
      console.log(
        `ProdutosLocalService: Sincronização já está ativa para empresa ${empresaId}`,
      );
      return;
    }
    this.databaseEmpresa = `${this.database}-${empresaId}`;
    if (!this.dbLocalRepository) {
      this.dbLocalRepository = new PouchDbRepository(this.databaseEmpresa);
    }
    this.dbLocalRepository.startLiveSync();
  }

  static stopSincronizacao() {
    if (this.dbLocalRepository) {
      this.dbLocalRepository.stopSync(true);
      this.dbLocalRepository = null;
      console.log("ProdutosLocalService: Sincronização interrompida");
    }
  }

  static async getAll(filtros, opcoes) {
    if (!this.dbLocalRepository) {
      return [];
    }
    return await this.dbLocalRepository.getAll(filtros, opcoes);
  }

  static async deletarDatabase(empresaId) {
    this.databaseEmpresa = `${this.database}-${empresaId}`;
    if (!this.dbLocalRepository) {
      this.dbLocalRepository = new PouchDbRepository(this.databaseEmpresa);
    }
    await this.dbLocalRepository.deleteDatabase();
    this.dbLocalRepository = null;
    storageHelper.removeLocal(`_pouch_${this.databaseEmpresa}`);
    console.log("ProdutosLocalService: Database deletada");
  }
}
